// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
import * as React from 'react';
import { Icon } from '@ta/styleguide.icon';
import { connect } from 'react-redux';
import classNames from '@ta/common.classnames';
import styles from './ListItem.less';

/** It's small or large. */
export type ListSize = 'small' | 'large';

/** Expected props for a ListItem. */
type ExternalProps = {|
  iconName: string,
  localizedText: string,
  size: ListSize,
  onClickFunction?: (SyntheticEvent<*>) => any,
|};

/** Connected prop types - provided by Redux. */
type ListItemProps = {|
  ...ExternalProps,
  imgCdnUrl: string,
|};

const ListItem = ({ iconName, localizedText, onClickFunction, imgCdnUrl, size }: ListItemProps) => (
  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
  <li
    onClick={onClickFunction}
    className={classNames('ui_link', styles.listItem, {
      [styles.small]: size === 'small',
      [styles.large]: size === 'large',
    })}
  >
    {iconName.startsWith('/') ? (
      <img
        src={`${imgCdnUrl}${iconName}`}
        className={classNames(styles.img, {
          [styles.small]: size === 'small',
          [styles.large]: size === 'large',
        })}
      />
    ) : (
      <Icon
        name={iconName}
        className={classNames(styles.icon, {
          [styles.small]: size === 'small',
          [styles.large]: size === 'large',
        })}
      />
    )}
    <span>{localizedText}</span>
  </li>
);

ListItem.defaultProps = {
  onClickFunction: () => false,
};

export default connect<ListItemProps, ExternalProps, _, _, _, _>(redux => ({
  imgCdnUrl: redux.meta.imageCdnUrl,
}))(ListItem);
